<template>
  <v-container fluid>
    <!-- Header elegante -->
    <v-row>
      <v-col cols="12" class="pa-0">
          <h2 class="text-h5 font-weight-bold white--text mb-5 ml-5 mt-5">
            <v-icon left color="white">mdi-account-multiple-outline</v-icon>
            Administración de Usuarios
          </h2>
      </v-col>
    </v-row>

    <v-data-table
      :headers="headers"
      :items="users"
      dense
      class="elevation-1"
      disable-pagination
    >
      <template v-slot:[`item.isAdmin`]="{ item }">
        <v-chip small :color="item.isAdmin ? 'orange' : 'secondary lighten-2'" dark>
          <v-icon left small>
            {{ item.isAdmin ? 'mdi-shield-account' : 'mdi-account-outline' }}
          </v-icon>
          {{ item.isAdmin ? 'Administrador' : 'Usuario' }}
        </v-chip>
      </template>

      <template v-slot:[`item.active`]="{ item }">
        <v-icon :color="item.active ? 'success lighten-1' : 'error lighten-1'">
          {{ item.active ? 'mdi-check-circle' : 'mdi-close-circle' }}
        </v-icon>
      </template>

      <template v-slot:[`item.actions`]="{ item }">
        <v-btn icon small color="secondary lighten-2" @click="openPermissions(item)" title="Permisos">
          <v-icon>mdi-key-outline</v-icon>
        </v-btn>
        <v-btn icon small color="secondary lighten-2" @click="openNotifications(item)" title="Notificaciones">
          <v-icon>mdi-bell-outline</v-icon>
        </v-btn>
      </template>
    </v-data-table>

    <!-- Modales -->
    <UserPermissionsDialog
      v-if="showPermissions"
      :user="selectedUser"
      @close="showPermissions = false"
    />
    <UserNotificationsDialog
      v-if="showNotifications"
      :user="selectedUser"
      @close="showNotifications = false"
    />
  </v-container>
</template>

<script>
import UserPermissionsDialog from '../components/User/UserPermissionsDialog.vue'
import UserNotificationsDialog from '../components/User/UserNotificationsDialog.vue'
import ClientUserService from '../services/ClientUserService'

export default {
  components: { UserPermissionsDialog, UserNotificationsDialog },
  data: () => ({
    users: [],
    selectedUser: null,
    showPermissions: false,
    showNotifications: false,
    headers: [
      { text: 'Nombre', value: 'firstName' },
      { text: 'Email', value: 'email' },
      { text: 'Administrador', value: 'isAdmin' },
      // { text: 'Rol', value: 'role' },
      { text: 'Activo', value: 'active' }
      // { text: 'Acciones', value: 'actions', sortable: false }
    ]
  }),
  async beforeMount () {
    const isLoggedIn = this.$store?.getters?.isLoggedIn
    const isAdmin = this.$store?.getters.user.isAdmin
    if (!isLoggedIn || !isAdmin) window.location.replace('/login')
  },
  async mounted () {
    await this.loadUsers()
  },
  methods: {
    async loadUsers () {
      try {
        const { items } = await ClientUserService.list({
          clientId: this.$store?.getters.user.clientId,
          isBluUser: false
        })
        this.users = items
      } catch (err) {
        console.error('Error loading users:', err)
      }
    },
    openPermissions (user) {
      this.selectedUser = user
      this.showPermissions = true
    },
    openNotifications (user) {
      this.selectedUser = user
      this.showNotifications = true
    }
  }
}
</script>

<style scoped>
.v-card-title {
  font-weight: 600;
  font-size: 1.1rem;
}
.v-data-table {
  border-radius: 8px;
}
.v-icon {
  vertical-align: middle;
}
</style>
